<template>
  <div class="contbg">
    <div class="cont">
      <div v-if="show" class="dingdanxx">
        <el-scrollbar style="height:100%;">
          <div class="huowuxq">
            <div>订单信息</div>
            <div>发货时间 ：{{infor.statusDtLoading}}</div>
          </div>
          <div class="huowuxq">
            <div>订单号 ：{{infor.shippingNoteNumber}}</div>
            <div>运费(元) ：{{infor.costPayShipping}}</div>
          </div>
          <div class="huowuxq">
            <div>货物名称 ：{{infor.descriptionOfGoods}}</div>
            <div>件数 ：{{infor.carNumberbc}}</div>
          </div>
          <div class="huowuxq">
            <div>货物类型 ：{{infor.goodsType_dictText}}</div>
            <div>重量(吨) ：{{infor.capacityBc}}</div>
          </div>
          <!-- <el-steps direction="vertical" :active="1" finish-status="success" :space="100">
            <el-step title="2022-01-15 02:10:45" description="张三（15555555，冀A12345）上传回执单"></el-step>
            <el-step title="2021-12-05 02:10:45" description="张三（15555555，冀A12345）上传回执单张三（15555555，冀A12345）上传回执单张三（15555555，冀A12345）上传回执单张三（15555555，冀A12345）上传回执单"></el-step>
            <el-step title="2021-12-05 02:10:45" description="张三（15555555，冀A12345）上传回执单张三"></el-step>
            <el-step title="2022-01-15 02:10:45" description="张三（15555555，冀A12345）上传回执单"></el-step>
          </el-steps> -->
          <el-timeline style="margin:30px 0 0 20px;">
            <el-timeline-item
                size="large"
                v-for="(activity, index) in activities"
                :color="activity.color"
                :key="index"
                :timestamp="activity.timestamp">
                {{activity.content}}
              </el-timeline-item>
            </el-timeline>
          </el-scrollbar>
      </div>
      <div class="dingdancx">
        <div class="dingdzhuiz">
          <div style="margin-bottom:20px;font-size:26px;color:#ed9c0d;">订单实时追踪</div>
          <div style="margin-bottom:60px;">快速定位订单运输信息，实时掌握订单咨询</div>
          <div>
            <input type="text" v-model="shippingNum" placeholder="输入单号为您智能查询" />
          </div>
          <div class="chaxunbtn" @click="gethyxx">点击查询</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shippingNum } from '@/utils/service'
export default {
  data(){
    return {
      shippingNum:'',
      show:false,
      infor:{},
      activities: []
    }
  },
  methods:{
    gethyxx(){
      if(this.shippingNum == ''){
        this.$alert('请输入正确的订单号后为您查询!', '温馨提示', {
          type:'warning',
          confirmButtonText: '确定'
        })
      }else{
        this.show = false
        this.infor = {}
        shippingNum({
          shippingNum:this.shippingNum
        }).then(data => {
          if(data == null){
            this.$alert('很抱歉，查无此订单信息，请确认后重试！', '温馨提示', {
              type:'warning',
              confirmButtonText: '确定'
            })
            this.show = false
            this.infor = {}
            this.activities = []
          }else{
            this.show = true
            this.infor = data
            this.activities = [
              {
                content: '运单创建时间',
                timestamp: data.createTime?data.createTime:'未创建',
                color: data.createTime?'#0bbd87':'#e4e7ed'
              }, 
              {
                content: '司机接单时间',
                timestamp: data.statusDtReceive?data.statusDtReceive:'未创建',
                color: data.statusDtReceive?'#0bbd87':'#e4e7ed'
              }, 
              {
                content: '运单发货时间',
                timestamp: data.statusDtLoading?data.statusDtLoading:'未创建',
                color: data.statusDtLoading?'#0bbd87':'#e4e7ed'
              },
              {
                content: '运费结算-运费核算时间',
                timestamp: data.accountingTime?data.accountingTime:'未创建',
                color: data.accountingTime?'#0bbd87':'#e4e7ed'
              }, 
              // {
              //   content: '运费结算-核算确认时间',   //??
              //   timestamp: data.accountingTime?data.accountingTime:'未创建',
              //   color: data.accountingTime?'#0bbd87':'#e4e7ed'
              // }, 
              {
                content: '运费结算-运费支付时间',
                timestamp: data.payDt?data.payDt:'未创建',
                color: data.payDt?'#0bbd87':'#e4e7ed'
              }, 
              {
                content: '申请开票时间',
                timestamp: data.billDtRequest?data.billDtRequest:'未创建',
                color: data.billDtRequest?'#0bbd87':'#e4e7ed'
              }, 
              {
                content: '开票完成时间',
                timestamp: data.billDtComplate?data.billDtComplate:'未创建',
                color: data.billDtComplate?'#0bbd87':'#e4e7ed'
              }
            ]
            this.activities.reverse()
          }
        })
      }
      
    }
  },
  mounted(){
    this.$nextTick(() => {
      if(this.$route.query.shippingNum){
        this.shippingNum = this.$route.query.shippingNum
        this.gethyxx()
      }
    })
  }
}
</script>

<style lang="stylus" scoped>
  .contbg
    background:url('../../assets/gengzbg.jpg') no-repeat top center
    background-size:100% 100%
    background-color: #085998
    .cont 
      width: 1200px
      height: 700px
      margin: 0 auto
      .dingdanxx
        width: 700px
        height: 450px
        margin-top: 100px
        padding:30px
        float:left
        background: #fff
        overflow: hidden
        .huowuxq
          display:-webkit-box
          display: -webkit-flex
          display: flex
          margin-bottom: 15px
          align-items: center
          justify-content: space-between
      .dingdancx
        width: 400px
        height: 500px
        margin-top: 100px
        float:right
        background:rgba(255,255,255,0.2)
        //opacity :0.5
      .dingdzhuiz
        width:270px
        margin:60px auto
        padding:40px 20px
        background: #fff
        text-align: center
        input
          width: 260px
          height: 50px
          padding:0 6px
          background: #b8cee5
          border: none
          border-radius:5px
          font-size: 16px
          color: #fff
      .chaxunbtn
          width: 260px
          height: 50px
          margin-top: 30px
          line-height: 50px
          font-size: 16px
          background: #08599A
          border-radius:5px
          color: #fff
          cursor:pointer
</style>